/** @file pivotOf: a facet entry's pivot in image pixels of the unflipped tile (pivotFrac x size). */
import type { FacetEntry } from '@zilo/pose3d-format/types/facet';

/** `[pivotFrac.x * w, pivotFrac.y * h]`, unrounded, before `halfPixel` (render-core applies both). Writes `out`. */
export function pivotOf(entry: FacetEntry, out: [number, number]): typeof out {
  out[0] = entry.pivotFrac[0] * entry.size[0];
  out[1] = entry.pivotFrac[1] * entry.size[1];
  return out;
}
